goog.provide('Blockly.Blocks');
